import { ListData } from "../types/List";
import { userApiUrl } from "./api";

const API_URL = "/Roles";

export const getData = async (): Promise<ListData[]> => {
  try {
    const res = await userApiUrl.get<ListData[]>(API_URL);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all roles error: ${error.response?.data?.message || error.message}`
    );
    return []; // Return empty array on error
  }
};
export const getRolePermissionsData = async (): Promise<ListData[]> => {
  try {
    const res = await userApiUrl.get<ListData[]>(`${API_URL}/role-permissions`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get role permissions error: ${
        error.response?.data?.message || error.message
      }`
    );
    return []; // Return empty array on error
  }
};

export const getDataById = async (id: number): Promise<ListData | null> => {
  try {
    const res = await userApiUrl.get<ListData>(`${API_URL}/${id}`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get role error: ${error.response?.data?.message || error.message}`
    );
    return null; // Return null on error
  }
};
